<div class="client-verification-holder">

    <div class="confirm-holder" *ngIf="confirmMsg.length > 0; else content">
        <div *ngFor="let msg of confirmMsg" class="msg msg-success">
            {{ msg }}
        </div>
    </div>

    <ng-template #content>
        <h2 *ngIf="modalPayload?.title">{{ modalPayload.title }}</h2>
        <div class="description" *ngIf="modalPayload?.description">{{ modalPayload.description }}</div>

        <div class="message-holder">
            <!-- Success Messages -->
            <div *ngIf="successMsg.length > 0">
                <div *ngFor="let msg of successMsg" class="msg msg-success">
                    {{ msg }}
                </div>
            </div>

            <!-- Error Messages -->
            <div *ngIf="errorMsg.length > 0">
                <div *ngFor="let msg of errorMsg" class="msg msg-error">
                    {{ msg }}
                </div>
            </div>
        </div>

        <div class="input-box">

            <!-- <serviceos-ng-label>Code</serviceos-ng-label>
            <input
                [(ngModel)]="code"
                type="text"
                id="code"
                name="code"
            /> -->

            <form #codeFormRef="ngForm" [formGroup]="codeForm" novalidate>
                <div class="form-fields-holder">
                    <div class="input-holder">
                        <serviceos-ng-form-field>
                            <serviceos-ng-label>Enter Code</serviceos-ng-label>

                            <input
                            type="text"
                            id="code"
                            name="code"
                            formControlName="code"
                            [serviceosNgInput]="code?.value"
                            [error]="code?.invalid && formSubmitted"
                            />

                            <serviceos-ng-error-message>
                            <ng-container *ngIf="code?.invalid && formSubmitted">
                                Code is required
                            </ng-container>
                            </serviceos-ng-error-message>
                        </serviceos-ng-form-field>
                        <span class="btn" (click)="resend()">{{ isSend ? 'Resend Code' : 'Get Code' }}</span>
                    </div>
                </div>
                </form>


            
        </div>

        <div class="buttons-holder">
            <serviceos-ng-button (click)="submit()" >Submit</serviceos-ng-button>
            <serviceos-ng-button (click)="close()" >Later</serviceos-ng-button>
        </div>
    </ng-template>
    
    <serviceos-ng-local-loader [showLoader]="showLoader"></serviceos-ng-local-loader>

</div>